import React from 'react';

import Button from '@/core/components/Button';
import Icons from '@/core/components/Icons';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

export const LocationSubmitButton: React.FC<{ onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; loading?: boolean; count?: number; isDisabled?: boolean }> = ({
  onClick,
  loading,
  count,
  isDisabled,
}) => {
  const { t } = useTranslationContext(['common']);

  return (
    <Button type="submit" onClick={onClick} size={'medium'} isDisabled={isDisabled}>
      {loading ? (
        <Icons icon="spinner" size="20" color="button-primary" weight="bold" />
      ) : (
        <>
          <Icons icon="search" size="20" color="button-primary" weight="bold" />
          <span className="ml-2 inline-block text-content-button-primary">{t('inputs.city.submit', { ns: 'common', count })}</span>
        </>
      )}
    </Button>
  );
};
